import { OfflineDataEncryption } from '../../../utils/offlineDataEncryption/OfflineDataEncryption.util';
import { OfflineDatabase } from '../offlineDatabase';

export const addEncryptMiddlewareToOfflineDatabase = (offlineDatabase: OfflineDatabase) => {
  offlineDatabase.use({
    stack: 'dbcore',
    name: 'encrypt',
    create: (downLevelDatabase) => ({
      ...downLevelDatabase,
      table(tableName) {
        const downlevelTable = downLevelDatabase.table(tableName);
        const tableIndexes = downlevelTable.schema.indexes;
        const fieldsToIgnore = tableIndexes
          .map((index) => index.keyPath)
          .flat()
          .filter(Boolean) as string[];

        return {
          ...downlevelTable,
          mutate: async (req) => {
            const encryption = new OfflineDataEncryption();

            const request =
              req.type === 'add' || req.type === 'put'
                ? {
                    ...req,
                    values: req.values.map((value) => {
                      return encryption.encryptOfflineData({
                        input: value,
                        customFieldsToIgnore: fieldsToIgnore,
                      });
                    }),
                  }
                : req;

            return downlevelTable.mutate(request);
          },
        };
      },
    }),
  });
};
